import * as THREE from "three";
import Instruction from "./fw/instruction";
import THREEWindow from "./fw/threewindow";
import Controller from "./controller";
import WorldScreen from "./worldscreen";

export default class Flotsam extends Instruction {
    constructor () {
        super();

        this.name = "Flotsam";

        this.a.gamewindow = new THREEWindow();
        this.a.controller = new Controller();
        var worldscreen = new WorldScreen();

        this.attach(this.a.gamewindow);
        this.attach(worldscreen);
    }

    setup () {
        var g = this.game;

        this.external(() => {
            this.game.addFilterbus(this.a.controller, "flotsamcontroller");
        }, () => {
            this.game.removeFilterbus("flotsamcontroller");
        });
    }
}
